import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const ContactCTA = () => {
  return (
    <section data-testid="contact-cta-section" className="py-24 lg:py-36 border-t border-white/10">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <p className="text-xs tracking-[0.2em] uppercase text-ash mb-6">Want to work together?</p>
          <h2 className="font-heading font-light text-4xl sm:text-6xl lg:text-7xl tracking-tight text-cream text-balance max-w-4xl">
            Let's build something people genuinely enjoy using.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-12 flex flex-wrap items-center gap-4">
            <Link
              to="/contact"
              data-testid="cta-contact-button"
              className="group inline-flex items-center gap-2 rounded-full bg-cream text-ink font-medium px-8 py-4 hover:bg-white transition-colors"
            >
              Start a conversation
              <ArrowUpRight size={18} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
            <a
              href="mailto:nishantgathwal@gmail.com"
              data-testid="cta-email-button"
              className="inline-flex items-center gap-2 rounded-full border border-white/20 text-cream font-medium px-8 py-4 hover:bg-white/10 transition-colors"
            >
              nishantgathwal@gmail.com
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default ContactCTA;
